import { compile, type Element, serialize, stringify } from 'stylis';

export interface ParsedCustomCSS {
  external: string;
  internal: string;
}

export interface ParseCustomCSSOptions {
  widgetRootSelector?: string;
}

export function parseCustomCSS(
  css: string,
  { widgetRootSelector }: ParseCustomCSSOptions = {}
): ParsedCustomCSS {
  let external = '';

  function process(element: Element) {
    switch (element.type) {
      // copy @external rules
      case '@external':
        external += serialize(element.children as Element[], process);
        return undefined;

      // replace :widget placeholder with widgetRootSelector value
      case 'rule':
        if (widgetRootSelector) {
          const props = element.props as string[];
          for (const [i, prop] of props.entries()) {
            props[i] = prop.replace(':widget', widgetRootSelector);
          }
        }
        break;

      default:
        break;
    }

    return serialize([element], stringify);
  }

  const internal = serialize(compile(css), process);
  const customCSS: ParsedCustomCSS = { external, internal };

  return customCSS;
}
